var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-wrapper"},[_c('Rate',{staticClass:"formily-switch",attrs:{"disabled":_vm.disabled,"max":_vm.max},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }